export type ProfileCategory = 'GAS' | 'GLUE' | 'BRAKE';

export const PROFILE_CATEGORIES = {
  GAS: {
    name: 'Gas',
    emoji: '⛽',
    description: 'Drives momentum and pushes growth',
    color: '#FB923C', // Orange (matches D - Drive)
    trait: 'D (Drive)'
  },
  GLUE: {
    name: 'Glue',
    emoji: '🧲',
    description: 'Binds people together and builds culture',
    color: '#E879F9', // Fuchsia (matches C - Connection)
    trait: 'C (Connection)'
  },
  BRAKE: {
    name: 'Brake',
    emoji: '🛑',
    description: 'Ensures quality and maintains stability',
    color: '#4ADE80', // Green (matches O - Order)
    trait: 'T (Task) & O (Order)'
  }
} as const;

export const PROFILE_CATEGORY_MAPPING: Record<string, ProfileCategory> = {
  // GAS - A-Dominant (7 profiles)
  'HLLL': 'GAS',      // Independent
  'HLHL': 'GAS',      // Achiever
  'HHLH': 'GAS',      // Executive
  'HHHH': 'GAS',      // Luminary
  'HHLL-AHDH': 'GAS', // Charger
  'HLHH': 'GAS',      // Catalyst
  'HHLL-AHDL': 'GAS', // Builder (A=0.90 tied with D)
  
  // GLUE - B-Dominant (5 profiles)
  'LHLL': 'GLUE',     // Networker
  'LHHL': 'GLUE',     // Supporter
  'HHHL': 'GLUE',     // Commander
  'HHLL-BHDH': 'GLUE', // Closer (B=0.90 tied with D)
  'HHLL-BHDL': 'GLUE', // Uniter (B=0.90 highest)
  
  // BRAKE - C/D-Dominant (7 profiles)
  'LHHH': 'BRAKE',    // Connector (C)
  'LLHL': 'BRAKE',    // Steady (C)
  'LLLL': 'BRAKE',    // Harmonizer (all traits moderate-low, seeks balance)
  'LLLH': 'BRAKE',    // Collaborator (D)
  'HLLH': 'BRAKE',    // Pioneer (D)
  'LHLH': 'BRAKE',    // Spark (D)
  'LLHH': 'BRAKE'     // Systematizer (D)
};

export const getCategoryForProfile = (pattern: string): ProfileCategory => {
  return PROFILE_CATEGORY_MAPPING[pattern] || 'BRAKE';
};
